import { DocumentsNotAvailableError } from "../exceptions/DocumentsNotAvailableError";
import { get } from "../lib/fetchUtil";

export interface Document {
  id: string;
  letterDate: string;
  type: string;
  fileContent: string;
  fileExtension: string;
}

export async function fetchDocuments(policyNumber: string, productCode: string | null): Promise<Document[]> {
  const response = await get(`documents/list?policyNumber=${policyNumber}&productCode=${productCode}`);

  if (response.status === 200) {
    return response.json();
  }

  if (response.status === 412) {
    throw new DocumentsNotAvailableError();
  }

  throw Error("FAILED_FETCH_DOCUMENTS");
}

export async function getDocument(policyNumber: string, fileId: string, productCode: string | null): Promise<Document> {
  const response = await get(`documents/get?policyNumber=${policyNumber}&fileId=${fileId}&productCode=${productCode}`);

  if (response.status === 200) {
    return response.json();
  } else {
    throw Error("FAILED_GET_DOCUMENT");
  }
}
